<template>
    <v-layout row justify-center>
        <v-dialog :value="show" persistent max-width="600">
            <v-card>
                <v-card-title class="warning headline white--text">
                    <v-layout>
                        <v-flex xs9>
                            <span>{{ $t('closestAvailsModal.title') }}</span>
                        </v-flex>
                        <v-flex xs3 text-right>
                            <v-btn icon @click="$emit('close')">
                                <v-icon large color="white">
                                    close
                                </v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <!-- Layout with closest avails -->
                    <v-layout v-if="hasClosestAvails" row wrap>
                        <v-flex xs12 mb-6>
                            <span>{{ $t('closestAvailsModal.timeNoLongerAvail') }}</span>
                        </v-flex>
                        <v-flex xs12 mb-2>
                            <span>{{ $t('closestAvailsModal.chooseAnotherAvail') }}</span>
                        </v-flex>
                        <template v-for="ts in closestTimeSlotSorted">
                            <v-flex
                                xs5
                                sm2
                                my-1
                                mx-2
                                class="text-center"
                                :key="ts.time">
                                <v-btn
                                    color="primary"
                                    text-color="white"
                                    class="time-chip subheading py-1"
                                    rounded
                                    large
                                    :disabled="btnTimeSlotDisabled"
                                    @click="selectedTimeSlot(ts.time)">
                                    {{ ts.time }}
                                </v-btn>
                            </v-flex>
                            <v-spacer :key="'spacer-' + ts.time" />
                        </template>
                        <v-flex xs12 mt-6>
                            <span>{{ $t('closestAvailsModal.returnToCalendar') }}</span>
                        </v-flex>
                    </v-layout>

                    <!-- Layout without closest avails -->
                    <v-layout v-else row wrap>
                        <v-flex xs12 mt-6>
                            <span>{{ $t('closestAvailsModal.noClosestAvail') }}</span>
                        </v-flex>
                        <v-flex xs12 mt-6>
                            <span>{{ $t('closestAvailsModal.noClosestAvailGotoCalendar') }}</span>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-flex text-center>
                        <v-btn
                            color="primary"
                            :loading="btnCalendarLoading"
                            :disabled="btnTimeSlotDisabled"
                            @click="gotoCalendar">
                            {{ $t('closestAvailsModal.toCalendarBtn') }}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>

import { mapGetters } from 'vuex';
import { parse } from 'date-fns';
import { sortBy, uniqBy } from 'lodash';

export default {
    name: 'closest-avails-modal',
    props: {
        show: { type: Boolean, required: true },
        target: { type: Date, required: false, default: () => new Date() },
    },
    data() {
        return {
            btnCalendarLoading: false,
            btnTimeSlotDisabled: false,
        };
    },
    computed: {
        ...mapGetters({
            extractTimeSlots: 'availabilities/extractTimeSlots',
            getClosestAvailabilities: 'availabilities/getClosestAvailabilities',
        }),

        /**
         * Returns true if there at least one closest avail
         */
        hasClosestAvails() {
            return !!this.getClosestAvailabilities.length;
        },

        /**
         * Builds and returns the array of uniq timeslot from all closest availabilities
         */
        allTimeSlots() {
            return uniqBy(this.extractTimeSlots(this.getClosestAvailabilities), 'timeMS');
        },

        /**
         * Returns the target (DateTime) in millisecond from 1970-01-01
         */
        targetMS() {
            return parse(this.target).getTime();
        },

        /**
         * Returns a sorted timeslot array based on the difference of the timeslot with the target
         */
        allTimeSlotsSorted() {
            return sortBy(this.allTimeSlots, (ts) => {
                return ts.timeMS - this.targetMS;
            });
        },

        /**
         * Returns only the fourth first timeslot from the sorted Timeslots array
         */
        closestTimeSlot() {
            return this.allTimeSlotsSorted.slice(0, 4);
        },

        /**
         * Returns a timeslot array (only the fourth first) sorted by datetime
         */
        closestTimeSlotSorted() {
            return sortBy(this.closestTimeSlot, 'timeMS');
        },
    },
    watch: {
        /**
         * When the modal is closed clear the closest avails vuex store and reset button state
         */
        show: function(value) {
            if (!value) {
                this.$store.commit('availabilities/UPDATE_CLOSEST_AVAILABILITIES', []);
                this.btnTimeSlotDisabled = false;
                this.btnCalendarLoading = false;
            }
        },
    },
    methods: {
        /**
         * Set button state and emit the 'gotoCalendar' event
         */
        gotoCalendar() {
            this.btnCalendarLoading = true;
            this.btnTimeSlotDisabled = true;
            this.$emit('gotoCalendar');
        },

        /**
         * Set button state and emit the 'selectedTimeSlot' event
         */
        selectedTimeSlot(time) {
            this.btnTimeSlotDisabled = true;
            this.$emit('selectedTimeSlot', time);
        },
    },
};
</script>
